module.exports = __webpack_public_path__ + "Segment7Standard.e5ff00da0a1f8a2cfd6f.otf";


//////////////////
// WEBPACK FOOTER
// ./src/Segment7Standard.otf
// module id = 765
// module chunks = 2